// extracted by mini-css-extract-plugin
export default {"loaderSection":"loaderWhite_loaderSection__tPXyQ","loaderSecitionh1":"loaderWhite_loaderSecitionh1__XnR7U","lds_ring":"loaderWhite_lds_ring__u+Iy+"};